import { toggleClass } from '@utils/domUtils';

export default class JobBoostingChannelCard {
  static selectorString() {
    return '.JobBoostingChannelCard';
  }

  render(node, props) {
    [...node.querySelectorAll('.button-toggle-details')].forEach(element =>
      element.addEventListener('click', this.toggleDetails.bind(this)),
    );
  }

  toggleDetails(event) {
    event.preventDefault();

    toggleClass(this.node, 'show-details');
  }
}
